import { BackupInfoBlock } from "../../repository/RepositoryDetails"



export const BackupInfoModal = ({ onClose, data }) => {
    return (
        <BackupInfoBlock className="!p-0 !shadow-none" owner={data.owner} repoId={data.repoId} repo={data.repo} backup={data.backup} onClose={onClose} singleColumn={false}/>
    )
}